"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function TextProffingLayoutSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 112, height: 77, viewBox: "0 0 112 77", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "M14 11H58V13H14V11ZM14 17H94V19H14V17ZM80 23H14V25H80V23Z", fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.6, x: 24, y: 34, width: 23, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.6, x: 14, y: 31, width: 7, height: 7, rx: 1, fill: "#597EFF" }),
        react_1.default.createElement("path", { d: "M15.8462 34.0769L17.6923 35.9231L22 31.6154", stroke: "white", strokeWidth: 1.23077 }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 44C13 42.8954 13.8954 42 15 42H96C97.1046 42 98 42.8954 98 44V66C98 67.1046 97.1046 68 96 68H15C13.8954 68 13 67.1046 13 66V44Z", fill: "#597EFF", fillOpacity: 0.1 }),
        react_1.default.createElement("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "M20.3913 46H75.8261V48H20.3913V46Z", fill: "#597EFF" }));
}
function TextProffingLayout(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(TextProffingLayoutSvg, Object.assign({}, svgProps)));
}
exports.default = TextProffingLayout;
//# sourceMappingURL=TextProffingLayout.js.map